<template>
  <div>
    <v-list class="pa-0 part-quantities-list mt-1"
            v-if="$vuetify.breakpoint.name === 'xs'">
      <v-list-item v-for="partQuantity in partQuantities"
                   :key="partQuantity.part.id"
                   class="pa-0"
                   style="min-height: unset">
        <v-list-item-content class="pa-0">
          <v-list-item-title>
            <div class="d-flex flex-row">
              <div class="flex-grow-1 "
                   style="white-space: normal;">{{ partQuantity.part | part }}
              </div>
              <div class="d-inline-flex flex-row align-baseline">
                <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    v-model="partQuantity.quantity"
                    class="right-align-number-input mt-1 mb-2 mr-3 ml-3"
                    min="0"
                    type="number"
                    :placeholder="$t('plannedService.quantity')"
                    style="max-width: 5em;"
                    :rules="[buildRequiredValidator()]"/>
                <div style="width:2em;">{{ partQuantity.part.trackingUnit.unit | unit }}</div>
              </div>
            </div>
            <v-divider class="mb-2"/>
          </v-list-item-title>

        </v-list-item-content>
        <v-list-item-action class="ma-0">
          <v-btn @click="removePart(partQuantity.part)"
                 icon
                 :title="$t('actions.delete')">
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-content class="pa-0">
          <part-select-field :show-select-dialog-button="true"
                             :show-add-dialog-button="true"
                             :dense="true"
                             @change="addPart"
                             v-model="partToAdd"
                             class="mb-1 mt-1"
                             :label="$t('actions.add')"/>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-data-table v-if="$vuetify.breakpoint.name !== 'xs'"
                  :headers="headers"
                  class="elevation-1 part-quantities-table"
                  hide-default-footer
                  :items="partQuantities"
                  dense
                  :no-data-text="'-'">
      <template v-slot:[`item.part`]="{ item }">
        {{ item.part | part }}
      </template>

      <template v-slot:[`item.quantity`]="{ item }">
        <div class="d-flex flex-row align-baseline">
          <v-text-field
              outlined
              dense
              hide-details="auto"
              v-model="item.quantity"
              class="shrink mr-2 right-align-number-input mt-1 mb-1"
              min="0"
              type="number"
              style="max-width: 6em;"
              :rules="[buildRequiredValidator()]"
          />
          <div class="flex-grow-1">{{ item.part.trackingUnit.unit | unit }}</div>
          <v-btn @click="removePart(item.part)"
                 icon :title="$t('actions.delete')">
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:footer>
        <div class="v-data-footer justify-start">
          <part-select-field :show-select-dialog-button="true"
                             :show-add-dialog-button="true"
                             :dense="true"
                             @change="addPart"
                             v-model="partToAdd"
                             class="mb-1 mt-1"
                             :label="$t('actions.add')"
                             :rules="rules"/>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import PartSelectField from '@/components/inputs/PartSelectField';
import { buildRequiredValidator } from '@/utils/ValidatorBuilders';

export default {
  name: 'PartQuantitiesSelect',
  components: { PartSelectField },
  props: {
    value: {
      required: true,
      type: Array,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    partToAdd: null,
  }),
  methods: {
    buildRequiredValidator,

    addPart(part) {
      if (!part) {
        return;
      }

      if (this.partQuantities.some((partQuantity => partQuantity.part.id === part.id))) {
        this.partToAdd = null;
        return;
      }

      let newPartQuantity = {
        part: part,
        quantity: 1,
      };

      this.partQuantities = [...this.partQuantities, newPartQuantity];
      this.partToAdd = null;
    },
    removePart(part) {
      this.partQuantities = this.partQuantities.filter((partQuantity => partQuantity.part.id !== part.id));

    },
  },

  computed: {
    partQuantities: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      },
    },


    headers() {
      return [
        {
          text: this.$t('part.singular'),
          align: 'start',
          sortable: false,
          value: 'part',
        },
        {
          text: this.$t('plannedService.quantity'),
          align: 'start',
          sortable: false,
          width: '18em',
          value: 'quantity',
        },
      ];
    },
  },

};
</script>

<style>

</style>
